// extracted by mini-css-extract-plugin
export var arrows = "_4p-5";
export var decrementer = "_4p-9";
export var disabled = "_4p-3";
export var error = "_4p-1";
export var hiddenText = "_4p-a";
export var incrementer = "_4p-8";
export var input = "_4p-7";
export var inputWrapper = "_4p-0";
export var readonly = "_4p-2";
export var regular = "_4p-6";
export var small = "_4p-4";